import { apiClient } from '@/lib/api';
import type {
  QuoteShipment,
  CreateQuoteShipmentData,
  UpdateQuoteShipmentData,
} from '../types/quote-shipment.types';

export const shipmentsService = {
  list: (quoteId: string) => apiClient.get<QuoteShipment[]>(`/api/quotes/${quoteId}/shipments`),

  create: (quoteId: string, data: CreateQuoteShipmentData) =>
    apiClient.post<QuoteShipment>(`/api/quotes/${quoteId}/shipments`, data),

  update: (quoteId: string, shipmentId: string, data: UpdateQuoteShipmentData) =>
    apiClient.patch<QuoteShipment>(`/api/quotes/${quoteId}/shipments/${shipmentId}`, data),

  remove: (quoteId: string, shipmentId: string) =>
    apiClient.delete(`/api/quotes/${quoteId}/shipments/${shipmentId}`),

  assignItems: (quoteId: string, shipmentId: string, lineItemIds: string[]) =>
    apiClient.post<QuoteShipment>(`/api/quotes/${quoteId}/shipments/${shipmentId}/assign-items`, {
      lineItemIds,
    }),

  recalculate: (quoteId: string, shipmentId: string) =>
    apiClient.post<QuoteShipment>(`/api/quotes/${quoteId}/shipments/${shipmentId}/recalculate`),

  unassignItems: (quoteId: string, shipmentId: string, lineItemIds: string[]) =>
    apiClient.post(`/api/quotes/${quoteId}/shipments/${shipmentId}/unassign-items`, {
      lineItemIds,
    }),

  createLeg: (quoteId: string, shipmentId: string, data: any) =>
    apiClient.post(`/api/quotes/${quoteId}/shipments/${shipmentId}/legs`, data),

  updateLeg: (quoteId: string, shipmentId: string, legId: string, data: any) =>
    apiClient.patch(`/api/quotes/${quoteId}/shipments/${shipmentId}/legs/${legId}`, data),

  deleteLeg: (quoteId: string, shipmentId: string, legId: string) =>
    apiClient.delete(`/api/quotes/${quoteId}/shipments/${shipmentId}/legs/${legId}`),

  addSurchargeToLeg: (
    quoteId: string,
    shipmentId: string,
    legId: string,
    data: { concept: string; type: 'PERCENTAGE' | 'FLAT'; value: number }
  ) =>
    apiClient.post(`/api/quotes/${quoteId}/shipments/${shipmentId}/legs/${legId}/surcharges`, data),

  deleteSurchargeFromLeg: (
    quoteId: string,
    shipmentId: string,
    legId: string,
    surchargeId: string
  ) =>
    apiClient.delete(
      `/api/quotes/${quoteId}/shipments/${shipmentId}/legs/${legId}/surcharges/${surchargeId}`
    ),

  loadFromRoute: (quoteId: string, shipmentId: string, routeId: string) =>
    apiClient.post(`/api/quotes/${quoteId}/shipments/${shipmentId}/load-from-route`, { routeId }),
};
